import type { IRuleEngineSnapshot } from '@modules/ruleEngine/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  isEmptyQueryField?: boolean;
  ruleEngineSnapshot: null | IRuleEngineSnapshot;
}

const initialState: IInitialState = {
  isEmptyQueryField: false,
  ruleEngineSnapshot: null,
};

const ruleEngineSlice = createSlice({
  initialState,
  name: 'ruleEngineSlice',
  reducers: {
    clearRuleEngineSnapshot(state: IInitialState) {
      state.ruleEngineSnapshot = null;
    },
    setRuleEngineSnapshot(
      state: IInitialState,
      action: PayloadAction<IRuleEngineSnapshot>
    ) {
      state.ruleEngineSnapshot = action.payload;
    },
    setIsEmptyQueryField(
      state: IInitialState,
      action: PayloadAction<IInitialState['isEmptyQueryField']>
    ) {
      state.isEmptyQueryField = action.payload;
    },
  },
});

export default ruleEngineSlice.reducer;

export const {
  setIsEmptyQueryField,
  setRuleEngineSnapshot,
  clearRuleEngineSnapshot,
} = ruleEngineSlice.actions;
